import { render, staticRenderFns } from "./ServicesApps.vue?vue&type=template&id=cf2815c0"
import script from "./ServicesApps.vue?vue&type=script&lang=js"
export * from "./ServicesApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports